import { DevsAPI } from '@/api';

export const DevsStore = {
  namespaced: true,
  state: {
    data: [],
    selected: {},
    show_modal: false,
    mode: '', // create || edit
  },
  mutations: {

    openModal(state) {
      state.show_modal = true;
    },

    toggleModal(state, status) {
      state.show_modal = status;
    },

    closeModal(state) {
      state.show_modal = false;
    },

    setData(state, data) {
      state.data = data;
    },

    setForEdit(state, data) {
      state.selected = _.cloneDeep(data);
      state.mode = 'edit';

      state.selected.avatar = state.selected.avatar ? state.selected.avatar : null;

      state.selected.available_from = state.selected.available_from ? (new Date(state.selected.available_from)).toISOString().substr(0, 10) : null;

      state.selected.exp.forEach(n => {
        if(n.to_date && n.to_date.length) {
          n.to_date = (new Date(n.to_date)).toISOString().substr(0, 10)
        }

        if(n.from_date && n.from_date.length) {
          n.from_date = (new Date(n.from_date)).toISOString().substr(0, 10)
        }
      })

      state.selected.education.forEach(n => {
        if(n.to_date && n.to_date.length) {
          n.to_date = (new Date(n.to_date)).toISOString().substr(0, 10)
        }

        if(n.from_date && n.from_date.length) {
          n.from_date = (new Date(n.from_date)).toISOString().substr(0, 10)
        }
      })
    },

    setForCreate(state) {
      state.selected = _.cloneDeep(ForumDTO);
      state.mode = 'create';
    },
  },
  actions: {

    updateData({ state, commit }) {
      return DevsAPI.selectAll().then(res => {
        commit('setData', res.data);
      })
    },

    async save({ state, commit, dispatch }) {
      if(state.mode === 'create') {
        await DevsAPI.create(state.selected)
      } else {
        await DevsAPI.update(state.selected._id, state.selected)
      }
      await dispatch('updateData');
      commit('closeModal');
    },

    async remove({ dispatch }, item) {
      await DevsAPI.remove(item._id)
      await dispatch('updateData');
    },
  },
  getters: {

    data(state) {
      return state.data;
    },

    mode(state) {
      return state.mode;
    },

    selected(state) {
      return state.selected;
    },

    showModal(state) {
      return state.show_modal;
    },
  }
};
